import { Component } from '@angular/core';

@Component({
  selector: 'app-set-password',
  imports: [],
  templateUrl: './set-password.html',
  styleUrl: './set-password.css'
})
export class SetPassword {

}
